import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Send, Loader2 } from "lucide-react";
import { act, api, useFetch } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Panel } from "@/components/common";
import { Sel } from "@/components/Sel";

const label = (c) => `${c.first_name} ${c.last_name || ""} · ${c.company || c.email}`.trim();

export const EmailPreview = ({ launchId, campaignId, version }) => {
  const { data: people } = useFetch(`/launches/${launchId}/sample-contacts`);
  const [who, setWho] = useState("");
  const [step, setStep] = useState(0);
  const [pv, setPv] = useState(null);
  const [sending, setSending] = useState(false);
  useEffect(() => { if (people?.length && !who) setWho(people[0].id); }, [people, who]);
  useEffect(() => {
    api.get(`/campaigns/${campaignId}/preview`, { params: { contact_id: who } }).then((r) => setPv(r.data)).catch(() => setPv(null));
  }, [campaignId, who, version]);
  if (!pv) return null;
  const s = pv.steps[step] || pv.steps[0];
  const opts = (people || []).map((c) => ({ value: c.id, label: label(c) }));
  const sendTest = async () => {
    setSending(true);
    const r = await act(() => api.post(`/campaigns/${campaignId}/test-send`, { step, contact_id: who }));
    setSending(false);
    if (r) toast.success(`Email ${step + 1} sent to ${r.to}`);
  };
  return (
    <Panel title="Inbox preview" action={opts.length > 0 && <Sel testid="email-preview-contact" className="w-72" value={who} onChange={setWho} options={opts} />}>
      <div className="flex gap-2 mb-3" data-testid="email-preview-steps">
        {pv.steps.map((x, i) => (
          <button key={i} type="button" data-testid={`email-preview-step-${i}`} onClick={() => setStep(i)}
            className={`text-xs px-3 py-1.5 rounded-md border transition-colors ${i === step ? "border-[#A855F7] bg-[#A855F7]/10 text-white" : "border-border text-zinc-400 hover:border-zinc-500"}`}>
            Email {i + 1} · day {x.day}
          </button>
        ))}
        <Button size="sm" variant="secondary" className="ml-auto" data-testid="email-preview-send-test-btn" disabled={sending} onClick={sendTest}>
          {sending ? <Loader2 className="w-3.5 h-3.5 mr-1.5 animate-spin" /> : <Send className="w-3.5 h-3.5 mr-1.5" />}
          Send this test to me
        </Button>
      </div>
      <div className="rounded-md overflow-hidden border border-border bg-white text-[#222]" data-testid="email-preview-frame">
        <div className="px-4 py-3 border-b border-zinc-200 text-xs space-y-0.5 bg-zinc-50">
          <div><span className="text-zinc-500 w-14 inline-block">From</span><b>{pv.from}</b>{pv.reply_to && <span className="text-zinc-500"> · replies to {pv.reply_to}</span>}</div>
          <div><span className="text-zinc-500 w-14 inline-block">To</span>{pv.to?.name ? `${pv.to.name} <${pv.to.email}>` : "Sample contact"}</div>
          <div className="text-sm pt-1"><span className="text-zinc-500 w-14 inline-block text-xs">Subject</span><b data-testid="email-preview-subject">{s.subject}</b></div>
        </div>
        <iframe title="email preview" srcDoc={s.html} className="w-full h-[460px] bg-white" sandbox="" data-testid="email-preview-iframe" />
      </div>
    </Panel>
  );
};
